import { useEffect, useState } from 'react'

// Returns: 'loading' | 'active' | 'inactive'
export default function useEntitlement(enabled, userId) {
	const [state, setState] = useState(enabled ? 'loading' : 'active')

	useEffect(() => {
		if (!enabled) return
		if (!userId) {
			// If we can’t identify the user, show paywall in-app.
			setState('inactive')
			return
		}

		let isMounted = true
		const abort = new AbortController()

		const check = async () => {
			try {
				// ⭐ NEW: Android reinstall/restore escape hatch
				const androidRestoreOverride =
					typeof window !== 'undefined' &&
					localStorage.getItem('androidRestoreOverride') === 'true'

				if (androidRestoreOverride) {
					if (!isMounted) return
					setState('active')
					return
				}

				const base = (process.env.REACT_APP_BACKEND_URL || '').replace(
					/\/+$/,
					'',
				)

				const url =
					`${base}/iap/entitlements/me` +
					`?userId=${encodeURIComponent(userId)}` +
					`&_=${Date.now()}`

				const res = await fetch(url, {
					headers: { Accept: 'application/json' },
					signal: abort.signal,
				})
				if (!res.ok) throw new Error(`HTTP ${res.status}`)
				const data = await res.json()

				if (!isMounted) return

				// ⭐ OPTIONAL: clear override once backend really confirms active
				if (data.active) {
					try {
						localStorage.removeItem('androidRestoreOverride')
					} catch {}
				}

				setState(data.active ? 'active' : 'inactive')
			} catch (e) {
				if (!isMounted) return
				console.log('[IAP] entitlement check failed:', e?.message || e)
				setState('inactive')
			}
		}

		check()

		const onVis = () => {
			if (document.visibilityState === 'visible') check()
		}
		document.addEventListener('visibilitychange', onVis)

		return () => {
			isMounted = false
			abort.abort()
			document.removeEventListener('visibilitychange', onVis)
		}
	}, [enabled, userId])

	return state
}
